import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
    IconBrandYoutube,
    IconBrandInstagram,
    IconBrandTiktok,
    IconBrandX,
} from "@tabler/icons-react";

const spots = [
    {
        title: "Haber & Analiz",
        copy: "Transferden taktik tahtasına — derinlemesine yazılar.",
        to: "/blog",
        label: "Bloga git",
    },
    {
        title: "Canlı Yayınlar",
        copy: "Maç sonu yorumları, röportajlar ve özel programlar.",
        to: "/#videos",
        label: "Videolara bak",
    },
    {
        title: "Hakkımızda",
        copy: "Bağımsız dijital spor kanalının hikâyesi.",
        to: "/about",
        label: "Keşfet",
    },
];

const socials = [
    {
        label: "YouTube",
        href: "https://www.youtube.com/@SportsDigitale",
        icon: IconBrandYoutube,
    },
    {
        label: "Instagram",
        href: "https://www.instagram.com/sportsdigitale/",
        icon: IconBrandInstagram,
    },
    {
        label: "TikTok",
        href: "https://www.tiktok.com/@sportsdigitale",
        icon: IconBrandTiktok,
    },
    {
        label: "Twitter",
        href: "https://x.com/SportsDigitale",
        icon: IconBrandX,
    },
];

export default function SpotlightRail() {
    return (
        <section className="w-11/12 max-w-7xl mx-auto py-16 md:py-20">
            <div className="mb-10 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
                <div>
                    <h2 className="font-display text-3xl md:text-4xl text-[var(--ink)]">Öne çıkanlar</h2>
                    <p className="mt-2 text-sm text-[var(--muted)] max-w-md">
                        Platformun üç ana damarı — tek bakışta.
                    </p>
                </div>

                <nav aria-label="Sosyal medya" className="flex flex-wrap items-center gap-2 md:gap-3">
                    {socials.map((social) => (
                        <a
                            key={social.label}
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 border border-[var(--line)] bg-[var(--surface)] px-3.5 py-2 text-sm text-[var(--ink)] transition-colors hover:border-[var(--accent)] hover:text-[var(--accent)]"
                        >
                            <social.icon size={16} stroke={1.5} />
                            <span className="font-medium">{social.label}</span>
                        </a>
                    ))}
                </nav>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                {spots.map((spot, i) => (
                    <motion.div
                        key={spot.title}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-40px" }}
                        transition={{ duration: 0.5, delay: i * 0.1 }}
                    >
                        <Link
                            to={spot.to}
                            className="group relative block h-full overflow-hidden border border-[var(--line)] bg-[var(--surface)] p-7 md:p-8 transition-colors hover:border-[var(--accent)]"
                        >
                            <span className="text-xs font-semibold tracking-widest text-[var(--accent)]">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <h3 className="mt-4 font-display text-2xl md:text-3xl text-[var(--ink)]">
                                {spot.title}
                            </h3>
                            <p className="mt-3 text-sm text-[var(--muted)] leading-relaxed">
                                {spot.copy}
                            </p>
                            <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[var(--ink)] group-hover:text-[var(--accent)] transition-colors">
                                {spot.label}
                                <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                                    →
                                </span>
                            </span>
                            <span className="pointer-events-none absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-[var(--accent)] transition-transform duration-500 group-hover:scale-x-100" />
                        </Link>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
